import {useGetProgramDetail} from '../context/useQuery'
import * as Component from 'src/feature/bite/component'
import {useIntl} from 'react-intl'
import {useEffect, useState} from 'react'
import {useReferral} from '../hook'
import {useDeleteRedeem, useUpdateReferralProgram} from '../context/useMutation'
import {useLocation, useNavigate} from 'react-router-dom'
import RefModal from './components/Modal'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'

function Referral() {
  const intl = useIntl()
  const {refetch, isLoading: isLoadingRefetch} = useGetProgramDetail()
  const {program, typeSet} = useReferral()
  const {mutateAsync, isLoading} = useUpdateReferralProgram()
  const {mutateAsync: deleteRedeem} = useDeleteRedeem()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isRemove, setIsRemove] = useState<{id: string; type: string} | null>(null)

  const location = useLocation()
  const navigate = useNavigate()

  const handleStatus = async () => {
    // Please set up both referrer and referee rewards before launching your Referrals Campaign
    // check if program?.referringCustomerRewardID && program?.referredFriendRewardID

    if (program?.status === 2) {
      if (!program?.referringCustomerRewardID || !program?.referredFriendRewardID) {
        toast.error(
          'Please set up both referrer and referee rewards before launching your Referrals Campaign'
        )
        return
      }
    }

    await mutateAsync({
      values: {
        ...program,
        status: program?.status === 1 ? 2 : 1,
      },
    })
    refetch()
  }

  const handleUpdate = async () => {
    await mutateAsync({values: program})
    refetch()
  }

  const handleRemove = async () => {
    if (!isRemove) return

    await deleteRedeem({
      redeemID: isRemove.id,
      program: {
        ...program,
        [isRemove.type]: null,
      },
    })

    setIsRemove(null)
    refetch()
  }

  // useEffect(() => {
  //   if (!isModalOpen) navigate(`/referral`)
  // }, [isModalOpen, location.pathname, navigate])

  useEffect(() => {
    // search for campaignId in url
    const search = new URLSearchParams(location.search)
    const campaignId = search.get('campaignId')
    if (campaignId) {
      setIsModalOpen(true)
    }
  }, [program])

  return (
    <>
      <Modal
        show={isRemove ? true : false}
        onHide={() => {
          setIsRemove(null)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({id: 'REFERRAL.REMOVE'})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{intl.formatMessage({id: 'REFERRAL.REMOVE.DESC'})} </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn btn-light'
            onClick={() => {
              setIsRemove(null)
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
          </button>
          <button
            className='btn btn-primary'
            onClick={() => {
              handleRemove()
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
          </button>
        </Modal.Footer>
      </Modal>
      <Component.Breadcrumb currentPage={intl.formatMessage({id: 'REFERRAL_PLURAL'})} />
      <div className='card mt-10'>
        <div className='card-header'>
          <div className='card-title d-flex flex-column'>
            <div className='d-flex align-items-center position-relative my-1'>
              <h3>{intl.formatMessage({id: 'REFERRAL_PLURAL'})}</h3>
              {program?.status === 1 ? (
                <span className='badge bg-success text-light ms-3'>
                  {intl.formatMessage({id: 'GLOBAL.ACTIVE'})}
                </span>
              ) : (
                <span className='badge bg-danger text-light ms-3'>
                  {intl.formatMessage({id: 'GLOBAL.INACTIVE'})}
                </span>
              )}
            </div>
          </div>
          <div className='card-toolbar'>
            <button
              className='btn btn-primary'
              onClick={handleStatus}
              disabled={isLoading || isLoadingRefetch}
            >
              {isLoading || isLoadingRefetch ? (
                intl.formatMessage({id: 'LOADING'})
              ) : (
                <>
                  {program?.status === 1
                    ? intl.formatMessage({id: 'GLOBAL.BUTTON.OFF'})
                    : intl.formatMessage({id: 'GLOBAL.BUTTON.ON'})}
                </>
              )}
            </button>
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-md-6 d-flex flex-column'>
              <span className='fs-4'>
                {program?.referringCustomerRewardName?.replace('Discount', 'Points') ||
                  intl.formatMessage({id: 'REFERRAL.NOT'})}
              </span>
              <span className='fs-6'>{intl.formatMessage({id: 'REFERRAL.REFERRERS'})}</span>
            </div>
            <div className='col-md-4 d-flex flex-end'>
              {program?.referringCustomerRewardID ? (
                <button
                  disabled={program?.referringCustomerRewardID ? false : true}
                  className='btn btn-danger me-4'
                  onClick={() => {
                    setIsRemove({
                      id: program?.referringCustomerRewardID || '',
                      type: 'referringCustomerRewardID',
                    })
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
                </button>
              ) : null}
              <button
                className='btn btn-primary'
                onClick={() => {
                  navigate(`/referral?campaignId=${program?.referringCustomerRewardID || 0}`)
                  typeSet('referringCustomerRewardID')
                  setIsModalOpen(true)
                }}
              >
                {program?.referringCustomerRewardID
                  ? intl.formatMessage({id: 'REFERRAL.EDIT'})
                  : intl.formatMessage({id: 'REFERRAL.CREATE'})}
              </button>
            </div>
          </div>
        </div>
        <div className='card-footer'>
          <div className='row'>
            <div className='col-md-6 d-flex flex-column'>
              <span className='fs-4'>
                {program?.referredFriendRewardName?.replace('Discount', 'Points') ||
                  intl.formatMessage({id: 'REFERRING.NOT'})}
              </span>
              <span className='fs-6'>{intl.formatMessage({id: 'REFERRAL.REFEREES'})}</span>
            </div>
            <div className='col-md-4 d-flex flex-end'>
              {program?.referredFriendRewardID ? (
                <button
                  className='btn btn-danger me-4'
                  disabled={program?.referredFriendRewardID ? false : true}
                  onClick={() => {
                    setIsRemove({
                      id: program?.referredFriendRewardID || '',
                      type: 'referredFriendRewardID',
                    })
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
                </button>
              ) : null}
              <button
                className='btn btn-primary'
                onClick={() => {
                  navigate(`/referral?campaignId=${program?.referredFriendRewardID || 0}`)
                  typeSet('referredFriendRewardID')
                  setIsModalOpen(true)
                }}
              >
                {program?.referredFriendRewardID
                  ? intl.formatMessage({id: 'REFERRAL.EDIT'})
                  : intl.formatMessage({id: 'REFERRAL.CREATE'})}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='card mt-10'>
        <div className='card-header'>
          <div className='card-title d-flex flex-column'>
            <div className='d-flex align-items-center position-relative my-1'>
              {intl.formatMessage({id: 'REFERRAL.REDIRECT'})}
            </div>
            <span className=' fs-6'>{intl.formatMessage({id: 'REFERRAL.REDIRECT.DESC'})}</span>
          </div>
          <div className='card-toolbar'>
            <button className='btn btn-primary' onClick={handleUpdate} disabled={isLoading}>
              {isLoading
                ? intl.formatMessage({id: 'LOADING'})
                : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
            </button>
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-md-6 d-flex flex-column'>
              <input
                type='text'
                className='form-control w-75'
                value={program?.referralRedirectionURL || ''}
                onChange={(e) => {
                  programSet({
                    referringCustomerRewardID: program?.referringCustomerRewardID || '',
                    referredFriendRewardID: program?.referredFriendRewardID || '',
                    status: program?.status || 0,
                    referringCustomerRewardName: program?.referringCustomerRewardName || '',
                    referredFriendRewardName: program?.referredFriendRewardName || '',
                    referralRedirectionURL: e.target.value,
                  })
                }}
                placeholder='https://example.com'
              />
            </div>
            <span className=' fs-6 mt-5'>{intl.formatMessage({id: 'REFERRAL.REDIRECT.HELP'})}</span>
          </div>
        </div>
      </div> */}

      {isModalOpen && (
        <RefModal
          status={program?.status}
          refetch={refetch}
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false)
            const search = new URLSearchParams(location.search)
            search.delete('campaignId')
            navigate(`/referral?${search.toString()}`)
          }}
        />
      )}
    </>
  )
}

export default Referral
